<template>

  <b-modal :id="menuPosition.value" :ref="menuPosition.value" centered scrollable hide-header-close
           title="منو مورد نظر را انتخاب کنید" header-bg-variant="dark"
           header-text-variant="light" @ok="onSubmitChange">
    <form @submit.stop.prevent="onSubmitChange">
      <b-form-input type="text" class="mt-2" v-model="selectMenu.position" readonly/>

      <form-group :validations="$v.selectMenu.menu_id">
        <div slot-scope="{ errors, invalid }">
          <b-form-select type="color" class="mt-2" v-model="selectMenu.menu_id" :options="selectOptions"/>
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>
    </form>

    <template #modal-footer="{ ok, cancel}">
      <b-row class="d-flex flex-row justify-content-around w-100">
        <b-button size="md" variant="success" @click="ok()">
          ثبت تغییر
        </b-button>
        <b-button size="md" variant="danger" @click="cancel()">
          انصراف
        </b-button>
      </b-row>
    </template>
  </b-modal>

</template>

<script>
import FormGroup from "../../validator/FormGroup";
import {required, minLength, maxLength, numeric} from "vuelidate/lib/validators";
import FormErrorsManager from '../../validator/FormErrorsManager.vue'

export default {
  name: "ChangeMenuModalForm",
  components: {FormGroup, FormErrorsManager},
  props:['menuPosition', 'selectMenu', 'selectOptions','menus'],
  data() {
    return {
      menuPositions: [
        {text:'منو اصلی فروشگاه', value:'store_nav'},
        {text:'منو فوتر سایت', value:'store_footer'},
        {text:'منو اصلی وبلاگ', value:'blog_nav'},
        {text:'منو فوتر وبلاگ', value:'blog_footer'} ],
    }
  },
  validations: {
    selectMenu: {
      menu_id: {required}
    },
  },
  methods: {
    changeMenu() {
      let menu = {}
      let currentMenu = this.getCurrentActiveItem(this.selectMenu.position)

      this.menus.forEach(element => (element.id === this.selectMenu.menu_id) ? menu = element : null)
      menu.position = this.selectMenu.position
      menu.status = 1
      menu.menu_id = menu.id

      if (currentMenu !== null) {
        this.$store.dispatch("Menu/updateMenu", currentMenu).then(res => {
          this.$store.dispatch("Menu/updateMenu", menu)
        })
      } else {
        this.$store.dispatch("Menu/updateMenu", menu)
      }

    },
    getCurrentActiveItem(position) {
      let currentMenu = null
      this.menus.forEach(element => (element.position === position && element.status === 1) ? currentMenu = element : null)
      if (currentMenu !== null) {
        delete currentMenu.position
        currentMenu.status = 0
        currentMenu.menu_id = currentMenu.id
      }
      return currentMenu
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmitChange(bvModalEvent){
      bvModalEvent.preventDefault()
      if (this.invalid()) {
        const form = this.selectMenu
        this.changeMenu()
        this.$nextTick(() => {
          this.$bvModal.hide(this.selectMenu.position)
        })
      }
    }
  },
}
</script>

<style scoped>
.set-font {
  font-size: 12px;
}

.zoom {
  transition: transform .4s;
  width: 100%;
}

.zoom:hover {
  transform: scale(1.05);
  background-color: #b5b6b3;
}

.add-menu-btn {
  width: 50px;
  height: 50px;
  position: fixed;
  bottom: 30px;
}
.add-menu-btn-container{
  position: absolute;
  width: max-content;
  right: 30px;
  bottom: 30px;
}
.menu-container{
  margin-top: 30px;
  height: 400px;
  overflow-y: scroll;
}

.menu-index-card .card-body{
  padding: 5px;
  width: 100%;
  border: none;
}
.menu-index-card{
  border: none;
}
</style>